import { FIRM_IMAGE_BASE } from "../../config/env";

const FirmLogo = ({ url }) => {
  return (
    <img
      src={FIRM_IMAGE_BASE + url}
      alt="Company Logo"
      className="firm-logo-sm-custom-v2"
    />
  );
};

export default FirmLogo;
